import UserActionTypes from '../user/user-types'

import SettingsActionTypes from './settings-types'
import { TDocumentRequests } from './types'

type TSettingsState = {
    loader: {
        ENV_JSON: boolean
        SUPPORTED_CURRENCIES: boolean
        SUPPORTED_LANGUAGES: boolean
        DOCUMENT_REQUEST: boolean
        CHANGE_PASSWORD: boolean
        UPLOAD_DOCUMENTS: boolean
        SUPPORT_DEPARTMENTS: boolean
        SUPPORT_CONVERSATIONS: boolean
        SUPPORT_UNREAD_CONVERSATIONS_COUNT: boolean
        SUPPORT_CONVERSATION_DETAILS: boolean
        SUPPORT_CONVERSATION_FILE: boolean
        NEW_SUPPORT_CONVERSATIONS: boolean
        REPLY_SUPPORT_CONVERSATIONS: boolean
        ARCHIVE_SUPPORT_CONVERSATIONS: boolean
        FETCH_SYSTEM_SETTINGS: boolean
        FETCH_SERVICE_PLANS: boolean
        FETCH_SERVICE_FEES_SCHEDULE: boolean
        FETCH_SERVICE_FEES_SCHEDULE_NO: boolean
        SERVICE_PLAN: boolean
        GET_NOTIFICATION: boolean
        POST_NOTIFICATION: boolean
        GET_DOCUMENT_FORMDATA: boolean
        GET_DYNAMIC_FORM: boolean
        DOCUMENT_REQUEST_FORM: boolean
        DYNAMIC_FORM_SUBMIT: boolean
        COMPANY_REGISTER_FORM: boolean
        BUSINESS_REGISTRATION: boolean
        SUBMIT_COMPANY_FORM_DOCUMENT: boolean
        CHANGE_MAIN_CURRENCY: boolean
        USER_SETTINGS: boolean
        COMPANIES_MEMBERS: boolean
        COMPANIES_MEMBERS_GROUPS: boolean
        SUBMIT_COMPANIES_MEMBER: boolean
        SUBMIT_COMPANIES_MEMBER_GROUP: boolean
        PUT_COMPANIES_MEMBER_GROUP: boolean
        REMOVE_COMPANIES_MEMBER_GROUP: boolean
        GET_FILE: boolean
        UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: boolean
    }
    loading: boolean
    success: {
        CHANGE_PASSWORD: boolean
        UPLOAD_DOCUMENTS: boolean
        SUPPORT_CONVERSATION_FILE: boolean
        NEW_SUPPORT_CONVERSATIONS: boolean
        REPLY_SUPPORT_CONVERSATIONS: boolean
        ARCHIVE_SUPPORT_CONVERSATIONS: boolean
        SERVICE_PLAN: boolean
        GET_DOCUMENT_FORMDATA: boolean
        GET_DYNAMIC_FORM: boolean
        DOCUMENT_REQUEST_FORM: boolean
        DYNAMIC_FORM_SUBMIT: boolean
        COMPANY_REGISTER_FORM: boolean
        BUSINESS_REGISTRATION: boolean
        SUBMIT_COMPANY_FORM_DOCUMENT: boolean
        SUBMIT_COMPANIES_MEMBER: boolean
        PUT_COMPANIES_MEMBER_GROUP: boolean
        REMOVE_COMPANIES_MEMBER_GROUP: boolean
        GET_FILE: boolean
        UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: boolean
    }
    error: any
    successData: any
    documentRequests: TDocumentRequests
    documentFormData: any
    supportedCurrencies: any
    supportedLanguages: any
    supportDepartmentsConversations: any
    supportConversations: any
    supportConversationDetails: any
    supportConversationFile: any
    supportUnreadConversations: any
    servicePlans: any
    notifications: any
    businessRegistrationDeposits: any
    settings: any
    features: any
    companyUsers: any
    companyUsersGroup: any
    file: any
    serviceFeesSchedule: any
    serviceFeesScheduleNo: any
    servicePlanDetails: any
    dynamicForm: any
    defaultOperationalCurrency: any
}

const INITIAL_STATE: TSettingsState = {
    loader: {
        ENV_JSON: false,
        SUPPORTED_CURRENCIES: false,
        SUPPORTED_LANGUAGES: false,
        DOCUMENT_REQUEST: false,
        CHANGE_PASSWORD: false,
        UPLOAD_DOCUMENTS: false,
        SUPPORT_DEPARTMENTS: false,
        SUPPORT_CONVERSATIONS: false,
        SUPPORT_UNREAD_CONVERSATIONS_COUNT: false,
        SUPPORT_CONVERSATION_DETAILS: false,
        SUPPORT_CONVERSATION_FILE: false,
        NEW_SUPPORT_CONVERSATIONS: false,
        REPLY_SUPPORT_CONVERSATIONS: false,
        ARCHIVE_SUPPORT_CONVERSATIONS: false,
        FETCH_SYSTEM_SETTINGS: false,
        FETCH_SERVICE_PLANS: false,
        FETCH_SERVICE_FEES_SCHEDULE: false,
        FETCH_SERVICE_FEES_SCHEDULE_NO: false,
        SERVICE_PLAN: false,
        GET_NOTIFICATION: false,
        POST_NOTIFICATION: false,
        GET_DOCUMENT_FORMDATA: false,
        GET_DYNAMIC_FORM: false,
        DOCUMENT_REQUEST_FORM: false,
        DYNAMIC_FORM_SUBMIT: false,
        COMPANY_REGISTER_FORM: false,
        BUSINESS_REGISTRATION: false,
        SUBMIT_COMPANY_FORM_DOCUMENT: false,
        CHANGE_MAIN_CURRENCY: false,
        USER_SETTINGS: false,
        COMPANIES_MEMBERS: false,
        COMPANIES_MEMBERS_GROUPS: false,
        SUBMIT_COMPANIES_MEMBER: false,
        SUBMIT_COMPANIES_MEMBER_GROUP: false,
        PUT_COMPANIES_MEMBER_GROUP: false,
        REMOVE_COMPANIES_MEMBER_GROUP: false,
        GET_FILE: false,
        UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: false,
    },
    loading: false,
    success: {
        CHANGE_PASSWORD: false,
        UPLOAD_DOCUMENTS: false,
        SUPPORT_CONVERSATION_FILE: false,
        NEW_SUPPORT_CONVERSATIONS: false,
        REPLY_SUPPORT_CONVERSATIONS: false,
        ARCHIVE_SUPPORT_CONVERSATIONS: false,
        SERVICE_PLAN: false,
        GET_DOCUMENT_FORMDATA: false,
        GET_DYNAMIC_FORM: false,
        DOCUMENT_REQUEST_FORM: false,
        DYNAMIC_FORM_SUBMIT: false,
        COMPANY_REGISTER_FORM: false,
        BUSINESS_REGISTRATION: false,
        SUBMIT_COMPANY_FORM_DOCUMENT: false,
        SUBMIT_COMPANIES_MEMBER: false,
        PUT_COMPANIES_MEMBER_GROUP: false,
        REMOVE_COMPANIES_MEMBER_GROUP: false,
        GET_FILE: false,
        UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: false,
    },
    error: null,
    successData: null,
    documentRequests: null,
    documentFormData: null,
    supportedCurrencies: null,
    supportedLanguages: null,
    supportDepartmentsConversations: null,
    supportConversations: null,
    supportConversationDetails: null,
    supportConversationFile: null,
    supportUnreadConversations: null,
    servicePlans: null,
    notifications: null,
    businessRegistrationDeposits: null,
    settings: null,
    features: null,
    companyUsers: null,
    companyUsersGroup: null,
    file: null,
    serviceFeesSchedule: null,
    serviceFeesScheduleNo: null,
    servicePlanDetails: null,
    dynamicForm: null,
    defaultOperationalCurrency: null,
}

const settingsReducer = (state = INITIAL_STATE, action): TSettingsState => {
    switch (action.type) {
        case SettingsActionTypes.FETCH_ON_PAGE_LOAD:
            return {
                ...state,
                loading: true,
                error: null,
            }

        case SettingsActionTypes.GET_ENV_JSON:
            return {
                ...state,
                loader: { ...state.loader, ENV_JSON: true },
            }
        case SettingsActionTypes.SUCCESS_ENV_JSON:
            return {
                ...state,
                loader: { ...state.loader, ENV_JSON: false },
                successData: { ...state.successData, ENV_JSON: action.payload },
            }
        case SettingsActionTypes.FAILURE_ENV_JSON:
            return {
                ...state,
                loader: { ...state.loader, ENV_JSON: false },
                successData: { ...state.successData, ENV_JSON: false },
            }

        case SettingsActionTypes.FETCH_SUPPORTED_CURRENCIES:
            return {
                ...state,
                loader: { ...state.loader, SUPPORTED_CURRENCIES: true },
            }
        case SettingsActionTypes.SUCCESS_SUPPORTED_CURRENCIES:
            return {
                ...state,
                loader: { ...state.loader, SUPPORTED_CURRENCIES: false },
                error: null,
                supportedCurrencies: action.payload,
            }

        case SettingsActionTypes.FETCH_SUPPORTED_LANGUAGES:
            return {
                ...state,
                loader: { ...state.loader, SUPPORTED_LANGUAGES: true },
            }
        case SettingsActionTypes.SUCCESS_SUPPORTED_LANGUAGES:
            return {
                ...state,
                loader: { ...state.loader, SUPPORTED_LANGUAGES: false },
                supportedLanguages: action.payload,
            }

        case SettingsActionTypes.FETCH_DOCUMENT_REQUEST:
            return {
                ...state,
                loader: { ...state.loader, DOCUMENT_REQUEST: true },
            }
        case SettingsActionTypes.SUCCESS_DOCUMENT_REQUEST:
            return {
                ...state,
                loader: { ...state.loader, DOCUMENT_REQUEST: false },
                documentRequests: { ...state.documentRequests, ...action.payload },
            }
        case SettingsActionTypes.FINISH_DOCUMENT_REQUEST:
            return {
                ...state,
                loader: { ...state.loader, DOCUMENT_REQUEST: false },
                documentRequests: null,
            }
        case SettingsActionTypes.FAILURE_DOCUMENT_REQUEST:
            return {
                ...state,
                loader: { ...state.loader, DOCUMENT_REQUEST: false },
                documentRequests: null,
            }

        case SettingsActionTypes.START_CHANGE_PASSWORD:
            return {
                ...state,
                loader: { ...state.loader, CHANGE_PASSWORD: true },
                success: { ...state.success, CHANGE_PASSWORD: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_CHANGE_PASSWORD:
            return {
                ...state,
                loader: { ...state.loader, CHANGE_PASSWORD: false },
                success: { ...state.success, CHANGE_PASSWORD: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_CHANGE_PASSWORD:
            return {
                ...state,
                loader: { ...state.loader, CHANGE_PASSWORD: false },
                success: { ...state.success, CHANGE_PASSWORD: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_CHANGE_PASSWORD:
            return {
                ...state,
                loader: { ...state.loader, CHANGE_PASSWORD: false },
                success: { ...state.success, CHANGE_PASSWORD: false },
                error: true,
            }

        case SettingsActionTypes.START_UPLOAD_DOCUMENTS:
            return {
                ...state,
                loader: { ...state.loader, UPLOAD_DOCUMENTS: true },
                success: { ...state.success, UPLOAD_DOCUMENTS: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_UPLOAD_DOCUMENTS:
            return {
                ...state,
                loader: { ...state.loader, UPLOAD_DOCUMENTS: false },
                success: { ...state.success, UPLOAD_DOCUMENTS: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_UPLOAD_DOCUMENTS:
            return {
                ...state,
                loader: { ...state.loader, UPLOAD_DOCUMENTS: false },
                success: { ...state.success, UPLOAD_DOCUMENTS: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_UPLOAD_DOCUMENTS:
            return {
                ...state,
                loader: { ...state.loader, UPLOAD_DOCUMENTS: false },
                success: { ...state.success, UPLOAD_DOCUMENTS: false },
                error: true,
            }

        case SettingsActionTypes.FETCH_SUPPORT_DEPARTMENTS:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_DEPARTMENTS: true },
            }
        case SettingsActionTypes.SUCCESS_SUPPORT_DEPARTMENTS:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_DEPARTMENTS: false },
                supportDepartmentsConversations: action.payload,
            }

        case SettingsActionTypes.FETCH_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_CONVERSATIONS: true },
            }
        case SettingsActionTypes.SUCCESS_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_CONVERSATIONS: false },
                supportConversations: action.payload,
            }
        case SettingsActionTypes.FAILURE_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_CONVERSATIONS: false },
                supportConversations: null,
            }

        case SettingsActionTypes.FETCH_SUPPORT_UNREAD_CONVERSATIONS_COUNT:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_UNREAD_CONVERSATIONS_COUNT: true },
            }
        case SettingsActionTypes.SUCCESS_SUPPORT_UNREAD_CONVERSATIONS_COUNT:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_UNREAD_CONVERSATIONS_COUNT: false },
                supportUnreadConversations: action.payload,
            }
        case SettingsActionTypes.FAILURE_SUPPORT_UNREAD_CONVERSATIONS_COUNT:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_UNREAD_CONVERSATIONS_COUNT: false },
                supportUnreadConversations: null,
            }

        case SettingsActionTypes.GET_SUPPORT_CONVERSATION_DETAILS:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_CONVERSATION_DETAILS: true },
                supportConversationDetails: null,
            }
        case SettingsActionTypes.SUCCESS_SUPPORT_CONVERSATION_DETAILS:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_CONVERSATION_DETAILS: false },
                supportConversationDetails: action.payload,
            }

        case SettingsActionTypes.START_SUPPORT_CONVERSATION_FILE:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_CONVERSATION_FILE: true },
            }
        case SettingsActionTypes.SUCCESS_SUPPORT_CONVERSATION_FILE:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_CONVERSATION_FILE: false },
                success: { ...state.success, SUPPORT_CONVERSATION_FILE: true },
                supportConversationFile: action.payload,
                error: null,
            }
        case SettingsActionTypes.FINISH_SUPPORT_CONVERSATION_FILE:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_CONVERSATION_FILE: false },
                success: { ...state.success, SUPPORT_CONVERSATION_FILE: false },
                supportConversationFile: null,
                error: null,
            }
        case SettingsActionTypes.FAILURE_SUPPORT_CONVERSATION_FILE:
            return {
                ...state,
                loader: { ...state.loader, SUPPORT_CONVERSATION_FILE: false },
                success: { ...state.success, SUPPORT_CONVERSATION_FILE: false },
                supportConversationFile: null,
                error: true,
            }

        case SettingsActionTypes.START_NEW_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, NEW_SUPPORT_CONVERSATIONS: true },
                success: { ...state.success, NEW_SUPPORT_CONVERSATIONS: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_NEW_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, NEW_SUPPORT_CONVERSATIONS: false },
                success: { ...state.success, NEW_SUPPORT_CONVERSATIONS: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_NEW_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, NEW_SUPPORT_CONVERSATIONS: false },
                success: { ...state.success, NEW_SUPPORT_CONVERSATIONS: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_NEW_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, NEW_SUPPORT_CONVERSATIONS: false },
                success: { ...state.success, NEW_SUPPORT_CONVERSATIONS: false },
                error: true,
            }

        case SettingsActionTypes.START_REPLY_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, REPLY_SUPPORT_CONVERSATIONS: true },
                success: { ...state.success, REPLY_SUPPORT_CONVERSATIONS: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_REPLY_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, REPLY_SUPPORT_CONVERSATIONS: false },
                success: { ...state.success, REPLY_SUPPORT_CONVERSATIONS: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_REPLY_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, REPLY_SUPPORT_CONVERSATIONS: false },
                success: { ...state.success, REPLY_SUPPORT_CONVERSATIONS: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_REPLY_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, REPLY_SUPPORT_CONVERSATIONS: false },
                success: { ...state.success, REPLY_SUPPORT_CONVERSATIONS: false },
                error: true,
            }

        case SettingsActionTypes.START_ARCHIVE_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, ARCHIVE_SUPPORT_CONVERSATIONS: true },
                success: { ...state.success, ARCHIVE_SUPPORT_CONVERSATIONS: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_ARCHIVE_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, ARCHIVE_SUPPORT_CONVERSATIONS: false },
                success: { ...state.success, ARCHIVE_SUPPORT_CONVERSATIONS: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_ARCHIVE_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, ARCHIVE_SUPPORT_CONVERSATIONS: false },
                success: { ...state.success, ARCHIVE_SUPPORT_CONVERSATIONS: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_ARCHIVE_SUPPORT_CONVERSATIONS:
            return {
                ...state,
                loader: { ...state.loader, ARCHIVE_SUPPORT_CONVERSATIONS: false },
                success: { ...state.success, ARCHIVE_SUPPORT_CONVERSATIONS: false },
                error: true,
            }

        case SettingsActionTypes.FETCH_SYSTEM_SETTINGS:
            return {
                ...state,
                loader: { ...state.loader, FETCH_SYSTEM_SETTINGS: true },
            }
        case SettingsActionTypes.SUCCESS_FETCH_SYSTEM_SETTINGS:
            return {
                ...state,
                loader: { ...state.loader, FETCH_SYSTEM_SETTINGS: false },
                features: action.payload?.features,
            }

        case SettingsActionTypes.FETCH_SERVICE_PLANS:
            return {
                ...state,
                loader: { ...state.loader, FETCH_SERVICE_PLANS: true },
            }
        case SettingsActionTypes.SUCCESS_FETCH_SERVICE_PLANS:
            return {
                ...state,
                loader: { ...state.loader, FETCH_SERVICE_PLANS: false },
                servicePlans: action.payload,
            }

        case SettingsActionTypes.FETCH_SERVICE_FEES_SCHEDULE:
            return {
                ...state,
                loader: { ...state.loader, FETCH_SERVICE_FEES_SCHEDULE: true },
            }
        case SettingsActionTypes.SUCCESS_FETCH_SERVICE_FEES_SCHEDULE:
            return {
                ...state,
                loader: { ...state.loader, FETCH_SERVICE_FEES_SCHEDULE: false },
                serviceFeesSchedule: action.payload,
            }

        case SettingsActionTypes.FETCH_SERVICE_FEES_SCHEDULE_NO:
            return {
                ...state,
                loader: { ...state.loader, FETCH_SERVICE_FEES_SCHEDULE_NO: true },
            }
        case SettingsActionTypes.SUCCESS_FETCH_SERVICE_FEES_SCHEDULE_NO:
            return {
                ...state,
                loader: { ...state.loader, FETCH_SERVICE_FEES_SCHEDULE_NO: false },
                serviceFeesScheduleNo: action.payload,
            }
        case SettingsActionTypes.FINISH_FETCH_SERVICE_FEES_SCHEDULE_NO:
            return {
                ...state,
                loader: { ...state.loader, FETCH_SERVICE_FEES_SCHEDULE_NO: false },
                serviceFeesScheduleNo: null,
            }

        case SettingsActionTypes.START_SERVICE_PLAN:
            return {
                ...state,
                loader: { ...state.loader, SERVICE_PLAN: true },
                success: { ...state.success, SERVICE_PLAN: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_SERVICE_PLAN:
            return {
                ...state,
                loader: { ...state.loader, SERVICE_PLAN: false },
                success: { ...state.success, SERVICE_PLAN: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_SERVICE_PLAN:
            return {
                ...state,
                loader: { ...state.loader, SERVICE_PLAN: false },
                success: { ...state.success, SERVICE_PLAN: false },
                servicePlans: null,
                servicePlanDetails: null,
                error: null,
            }
        case SettingsActionTypes.FAILURE_SERVICE_PLAN:
            return {
                ...state,
                loader: { ...state.loader, SERVICE_PLAN: false },
                success: { ...state.success, SERVICE_PLAN: false },
                error: true,
            }

        case SettingsActionTypes.START_GET_NOTIFICATION:
            return {
                ...state,
                loader: { ...state.loader, GET_NOTIFICATION: true },
            }
        case SettingsActionTypes.SUCCESS_GET_NOTIFICATION:
            return {
                ...state,
                loader: { ...state.loader, GET_NOTIFICATION: false },
                notifications: action.payload,
                error: null,
            }
        case SettingsActionTypes.FINISH_GET_NOTIFICATION:
            return {
                ...state,
                loader: { ...state.loader, GET_NOTIFICATION: false },
                notifications: null,
                error: null,
            }
        case SettingsActionTypes.FAILURE_GET_NOTIFICATION:
            return {
                ...state,
                loader: { ...state.loader, GET_NOTIFICATION: false },
                notifications: null,
                error: true,
            }

        case SettingsActionTypes.START_POST_NOTIFICATION:
            return {
                ...state,
                loader: { ...state.loader, POST_NOTIFICATION: true },
            }
        case SettingsActionTypes.SUCCESS_POST_NOTIFICATION:
            return {
                ...state,
                loader: { ...state.loader, POST_NOTIFICATION: false },
                notifications: action.payload,
                error: null,
            }
        case SettingsActionTypes.FINISH_POST_NOTIFICATION:
            return {
                ...state,
                loader: { ...state.loader, POST_NOTIFICATION: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_POST_NOTIFICATION:
            return {
                ...state,
                loader: { ...state.loader, POST_NOTIFICATION: false },
                error: true,
            }

        case SettingsActionTypes.START_GET_DOCUMENT_FORMDATA:
            return {
                ...state,
                loader: { ...state.loader, GET_DOCUMENT_FORMDATA: true },
            }
        case SettingsActionTypes.SUCCESS_GET_DOCUMENT_FORMDATA:
            return {
                ...state,
                loader: { ...state.loader, GET_DOCUMENT_FORMDATA: false },
                success: { ...state.success, GET_DOCUMENT_FORMDATA: true },
                documentFormData: action.payload,
            }
        case SettingsActionTypes.FINISH_GET_DOCUMENT_FORMDATA:
            return {
                ...state,
                loader: { ...state.loader, GET_DOCUMENT_FORMDATA: false },
                success: { ...state.success, GET_DOCUMENT_FORMDATA: false },
                documentFormData: null,
            }

        case SettingsActionTypes.START_GET_DYNAMIC_FORM:
            return {
                ...state,
                loader: { ...state.loader, GET_DYNAMIC_FORM: true },
                success: { ...state.success, GET_DYNAMIC_FORM: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_GET_DYNAMIC_FORM:
            return {
                ...state,
                loader: { ...state.loader, GET_DYNAMIC_FORM: false },
                success: { ...state.success, GET_DYNAMIC_FORM: true },
                dynamicForm: action.payload,
                error: null,
            }
        case SettingsActionTypes.FINISH_GET_DYNAMIC_FORM:
            return {
                ...state,
                loader: { ...state.loader, GET_DYNAMIC_FORM: false },
                success: { ...state.success, GET_DYNAMIC_FORM: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_GET_DYNAMIC_FORM:
            return {
                ...state,
                loader: { ...state.loader, GET_DYNAMIC_FORM: false },
                success: { ...state.success, GET_DYNAMIC_FORM: false },
                error: true,
            }

        case SettingsActionTypes.START_UPDATE_DYNAMIC_FORM:
            return {
                ...state,
                error: null,
            }
        case SettingsActionTypes.FAILURE_UPDATE_DYNAMIC_FORM:
            return {
                ...state,
                error: true,
            }

        case SettingsActionTypes.START_DOCUMENT_REQUEST_FORM:
            return {
                ...state,
                loader: { ...state.loader, DOCUMENT_REQUEST_FORM: true },
                success: { ...state.success, DOCUMENT_REQUEST_FORM: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_DOCUMENT_REQUEST_FORM:
            return {
                ...state,
                loader: { ...state.loader, DOCUMENT_REQUEST_FORM: false },
                success: { ...state.success, DOCUMENT_REQUEST_FORM: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_DOCUMENT_REQUEST_FORM:
            return {
                ...state,
                loader: { ...state.loader, DOCUMENT_REQUEST_FORM: false },
                success: { ...state.success, DOCUMENT_REQUEST_FORM: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_DOCUMENT_REQUEST_FORM:
            return {
                ...state,
                loader: { ...state.loader, DOCUMENT_REQUEST_FORM: false },
                success: { ...state.success, DOCUMENT_REQUEST_FORM: false },
                error: true,
            }
        case SettingsActionTypes.START_DYNAMIC_FORM_SUBMIT:
            return {
                ...state,
                loader: { ...state.loader, DYNAMIC_FORM_SUBMIT: true },
                success: { ...state.success, DYNAMIC_FORM_SUBMIT: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_DYNAMIC_FORM_SUBMIT:
            return {
                ...state,
                loader: { ...state.loader, DYNAMIC_FORM_SUBMIT: false },
                success: { ...state.success, DYNAMIC_FORM_SUBMIT: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_DYNAMIC_FORM_SUBMIT:
            return {
                ...state,
                loader: { ...state.loader, DYNAMIC_FORM_SUBMIT: false },
                success: { ...state.success, DYNAMIC_FORM_SUBMIT: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_DYNAMIC_FORM_SUBMIT:
            return {
                ...state,
                loader: { ...state.loader, DYNAMIC_FORM_SUBMIT: false },
                success: { ...state.success, DYNAMIC_FORM_SUBMIT: false },
                error: true,
            }

        case SettingsActionTypes.START_COMPANY_REGISTER_FORM:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_REGISTER_FORM: true },
                success: { ...state.success, COMPANY_REGISTER_FORM: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_COMPANY_REGISTER_FORM:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_REGISTER_FORM: false },
                success: { ...state.success, COMPANY_REGISTER_FORM: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_COMPANY_REGISTER_FORM:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_REGISTER_FORM: false },
                success: { ...state.success, COMPANY_REGISTER_FORM: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_COMPANY_REGISTER_FORM:
            return {
                ...state,
                loader: { ...state.loader, COMPANY_REGISTER_FORM: false },
                success: { ...state.success, COMPANY_REGISTER_FORM: false },
                error: true,
            }

        case SettingsActionTypes.START_BUSINESS_REGISTRATION:
            return {
                ...state,
                loader: { ...state.loader, BUSINESS_REGISTRATION: true },
                success: { ...state.success, BUSINESS_REGISTRATION: false },
                successData: { ...state.successData, BUSINESS_REGISTRATION: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_BUSINESS_REGISTRATION:
            return {
                ...state,
                loader: { ...state.loader, BUSINESS_REGISTRATION: false },
                success: { ...state.success, BUSINESS_REGISTRATION: true },
                successData: { ...state.successData, BUSINESS_REGISTRATION: action.payload },
                error: null,
            }
        case SettingsActionTypes.FINISH_BUSINESS_REGISTRATION:
            return {
                ...state,
                loader: { ...state.loader, BUSINESS_REGISTRATION: false },
                success: { ...state.success, BUSINESS_REGISTRATION: false },
                successData: { ...state.successData, BUSINESS_REGISTRATION: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_BUSINESS_REGISTRATION:
            return {
                ...state,
                loader: { ...state.loader, BUSINESS_REGISTRATION: false },
                success: { ...state.success, BUSINESS_REGISTRATION: false },
                successData: { ...state.successData, BUSINESS_REGISTRATION: false },
                error: true,
            }

        case SettingsActionTypes.START_SUBMIT_COMPANY_FORM_DOCUMENT:
            return {
                ...state,
                loader: { ...state.loader, SUBMIT_COMPANY_FORM_DOCUMENT: true },
                success: { ...state.success, SUBMIT_COMPANY_FORM_DOCUMENT: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_SUBMIT_COMPANY_FORM_DOCUMENT:
            return {
                ...state,
                loader: { ...state.loader, SUBMIT_COMPANY_FORM_DOCUMENT: false },
                success: { ...state.success, SUBMIT_COMPANY_FORM_DOCUMENT: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_SUBMIT_COMPANY_FORM_DOCUMENT:
            return {
                ...state,
                loader: { ...state.loader, SUBMIT_COMPANY_FORM_DOCUMENT: false },
                success: { ...state.success, SUBMIT_COMPANY_FORM_DOCUMENT: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_SUBMIT_COMPANY_FORM_DOCUMENT:
            return {
                ...state,
                loader: { ...state.loader, SUBMIT_COMPANY_FORM_DOCUMENT: false },
                success: { ...state.success, SUBMIT_COMPANY_FORM_DOCUMENT: false },
                error: true,
            }

        case SettingsActionTypes.START_CHANGE_MAIN_CURRENCY:
            return {
                ...state,
                loader: { ...state.loader, CHANGE_MAIN_CURRENCY: true },
            }
        case SettingsActionTypes.SUCCESS_CHANGE_MAIN_CURRENCY:
            return {
                ...state,
                defaultOperationalCurrency: action.payload,
                loader: { ...state.loader, CHANGE_MAIN_CURRENCY: false },
            }
        case UserActionTypes.SIGN_IN_SUCCESS: {
            const { defaultOperationalCurrency } = action.payload

            return {
                ...state,
                defaultOperationalCurrency,
            }
        }
        case SettingsActionTypes.GET_USER_SETTINGS:
            return {
                ...state,
                loader: { ...state.loader, USER_SETTINGS: true },
            }
        case SettingsActionTypes.SUCCESS_GET_USER_SETTINGS:
            return {
                ...state,
                settings: action.payload,
                loader: { ...state.loader, USER_SETTINGS: false },
            }

        case SettingsActionTypes.START_USER_SETTINGS:
            return {
                ...state,
                loader: { ...state.loader, USER_SETTINGS: true },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_USER_SETTINGS:
            return {
                ...state,
                loader: { ...state.loader, USER_SETTINGS: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_USER_SETTINGS:
            return {
                ...state,
                loader: { ...state.loader, USER_SETTINGS: false },
                error: true,
            }

        case SettingsActionTypes.GET_COMPANIES_MEMBERS:
            return {
                ...state,
                loader: { ...state.loader, COMPANIES_MEMBERS: true },
            }
        case SettingsActionTypes.SUCCESS_GET_COMPANIES_MEMBERS:
            return {
                ...state,
                companyUsers: action.payload,
                loader: { ...state.loader, COMPANIES_MEMBERS: false },
            }

        case SettingsActionTypes.GET_COMPANIES_MEMBERS_GROUPS:
            return {
                ...state,
                loader: { ...state.loader, COMPANIES_MEMBERS_GROUPS: true },
            }
        case SettingsActionTypes.SUCCESS_GET_COMPANIES_MEMBERS_GROUPS:
            return {
                ...state,
                companyUsersGroup: action.payload,
                loader: { ...state.loader, COMPANIES_MEMBERS_GROUPS: false },
            }

        case SettingsActionTypes.START_COMPANIES_MEMBER:
            return {
                ...state,
                loader: { ...state.loader, SUBMIT_COMPANIES_MEMBER: true },
                success: { ...state.success, SUBMIT_COMPANIES_MEMBER: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_COMPANIES_MEMBER:
            return {
                ...state,
                loader: { ...state.loader, SUBMIT_COMPANIES_MEMBER: false },
                success: { ...state.success, SUBMIT_COMPANIES_MEMBER: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_COMPANIES_MEMBER:
            return {
                ...state,
                loader: { ...state.loader, SUBMIT_COMPANIES_MEMBER: false },
                success: { ...state.success, SUBMIT_COMPANIES_MEMBER: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_COMPANIES_MEMBER:
            return {
                ...state,
                loader: { ...state.loader, SUBMIT_COMPANIES_MEMBER: false },
                success: { ...state.success, SUBMIT_COMPANIES_MEMBER: false },
                error: true,
            }

        case SettingsActionTypes.START_PUT_COMPANIES_MEMBER_GROUP:
            return {
                ...state,
                loader: { ...state.loader, PUT_COMPANIES_MEMBER_GROUP: true },
                success: { ...state.success, PUT_COMPANIES_MEMBER_GROUP: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_PUT_COMPANIES_MEMBER_GROUP:
            return {
                ...state,
                loader: { ...state.loader, PUT_COMPANIES_MEMBER_GROUP: false },
                success: { ...state.success, PUT_COMPANIES_MEMBER_GROUP: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_PUT_COMPANIES_MEMBER_GROUP:
            return {
                ...state,
                loader: { ...state.loader, PUT_COMPANIES_MEMBER_GROUP: false },
                success: { ...state.success, PUT_COMPANIES_MEMBER_GROUP: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_PUT_COMPANIES_MEMBER_GROUP:
            return {
                ...state,
                loader: { ...state.loader, PUT_COMPANIES_MEMBER_GROUP: false },
                success: { ...state.success, PUT_COMPANIES_MEMBER_GROUP: false },
                error: true,
            }

        case SettingsActionTypes.START_REMOVE_COMPANIES_MEMBER_GROUP:
            return {
                ...state,
                loader: { ...state.loader, REMOVE_COMPANIES_MEMBER_GROUP: true },
                success: { ...state.success, REMOVE_COMPANIES_MEMBER_GROUP: false },
                error: null,
            }
        case SettingsActionTypes.SUCCESS_REMOVE_COMPANIES_MEMBER_GROUP:
            return {
                ...state,
                loader: { ...state.loader, REMOVE_COMPANIES_MEMBER_GROUP: false },
                success: { ...state.success, REMOVE_COMPANIES_MEMBER_GROUP: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_REMOVE_COMPANIES_MEMBER_GROUP:
            return {
                ...state,
                loader: { ...state.loader, REMOVE_COMPANIES_MEMBER_GROUP: false },
                success: { ...state.success, REMOVE_COMPANIES_MEMBER_GROUP: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_REMOVE_COMPANIES_MEMBER_GROUP:
            return {
                ...state,
                loader: { ...state.loader, REMOVE_COMPANIES_MEMBER_GROUP: false },
                success: { ...state.success, REMOVE_COMPANIES_MEMBER_GROUP: false },
                error: true,
            }

        case SettingsActionTypes.START_GET_FILE:
            return {
                ...state,
                loader: { ...state.loader, GET_FILE: true },
            }
        case SettingsActionTypes.SUCCESS_GET_FILE:
            return {
                ...state,
                loader: { ...state.loader, GET_FILE: false },
                success: { ...state.success, GET_FILE: true },
                file: action.payload,
                error: null,
            }
        case SettingsActionTypes.FINISH_GET_FILE:
            return {
                ...state,
                loader: { ...state.loader, GET_FILE: false },
                success: { ...state.success, GET_FILE: false },
                file: null,
                error: null,
            }
        case SettingsActionTypes.FAILURE_GET_FILE:
            return {
                ...state,
                loader: { ...state.loader, GET_FILE: false },
                success: { ...state.success, GET_FILE: false },
                file: null,
                error: true,
            }

        case SettingsActionTypes.START_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS:
            return {
                ...state,
                loader: { ...state.loader, UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: true },
            }
        case SettingsActionTypes.SUCCESS_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS:
            return {
                ...state,
                loader: { ...state.loader, UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: false },
                success: { ...state.success, UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: true },
                error: null,
            }
        case SettingsActionTypes.FINISH_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS:
            return {
                ...state,
                loader: { ...state.loader, UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: false },
                success: { ...state.success, UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: false },
                error: null,
            }
        case SettingsActionTypes.FAILURE_UPLOAD_DOCUMENT_SOURCE_OF_FUNDS:
            return {
                ...state,
                loader: { ...state.loader, UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: false },
                success: { ...state.success, UPLOAD_DOCUMENT_SOURCE_OF_FUNDS: false },
                error: true,
            }

        default:
            return state
    }
}

export default settingsReducer
